"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.approvalAttachmentFrontendSchema = void 0;
var constants_1 = require("@hobt/constants");
exports.approvalAttachmentFrontendSchema = {
    type: 'object',
    // additionalProperties: {
    //   not: true,
    //   /* eslint-disable-next-line no-template-curly-in-string */
    //   errorMessage: '- should not have additional property ${0#}',
    // },
    required: ['documentID', 'fileName', 'fileByteCount'],
    properties: {
        documentID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        fileName: {
            type: 'string',
            minLength: 1,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters',
        },
        fileByteCount: {
            type: 'number',
            minimum: 0,
            errorMessage: 'Should be a positive number',
        },
        submitterUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        submitterUserTypeCode: {
            type: 'number',
            enum: Object.values(constants_1.UserType),
            errorMessage: 'Should equate to a valid UserType Enum value',
        },
        uploadStatusCode: {
            type: ['number', 'null'],
            enum: Object.values(constants_1.Status),
            errorMessage: 'Should equate to a valid Status Enum value',
        },
    },
};
